import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-application-grid',
  templateUrl: './loan-application-grid.component.html',
  styleUrls: ['./loan-application-grid.component.css']
})
export class LoanApplicationGridComponent implements OnInit {
  title="LoanApplicationList"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/loan-application-grid/loan-application-grid.component.ts